//请自行添加语言资源
const notice = {
  endDate:'结束时间',
  creator:'放入用户',
  updateTime:'更新时间',
  createTime:'发布时间',
  beginDate:'开始时间',
  title:'新闻标题',
  isUse:'是否启用',
  noticeObj:'新闻对象',
  content:'新闻内容',
  updater:'更新用户',
  msg:{
    title:'请输入新闻标题',
    content:'请输入新闻内容',
    noticeObj:'请选择新闻对象',
  }
};
export default notice



// WEBPACK FOOTER //
// ./src/page/system/noticeSys/lang/notice.zh.js